/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreatePccPatientResponse } from './CreatePccPatientResponse';
import {
    CreatePccPatientResponseFromJSON,
    CreatePccPatientResponseFromJSONTyped,
    CreatePccPatientResponseToJSON,
} from './CreatePccPatientResponse';

/**
 * 
 * @export
 * @interface CreatePccPatient201Response
 */
export interface CreatePccPatient201Response {
    /**
     * 
     * @type {CreatePccPatientResponse}
     * @memberof CreatePccPatient201Response
     */
    data?: CreatePccPatientResponse;
}

/**
 * Check if a given object implements the CreatePccPatient201Response interface.
 */
export function instanceOfCreatePccPatient201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreatePccPatient201ResponseFromJSON(json: any): CreatePccPatient201Response {
    return CreatePccPatient201ResponseFromJSONTyped(json, false);
}

export function CreatePccPatient201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePccPatient201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CreatePccPatientResponseFromJSON(json['data']),
    };
}

export function CreatePccPatient201ResponseToJSON(value?: CreatePccPatient201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreatePccPatientResponseToJSON(value.data),
    };
}

